import React, {useEffect, useState} from "react";
import "./ResetPasswordModal.styles.scss";
import {FiEye, FiEyeOff} from 'react-icons/fi';

const ResetPasswordModal = ({isOpen, onClose, onSubmit}) => {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setPassword("");
            setConfirmPassword("");
            setError("");
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const passwordRegex =
        /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}/;

    const handleSubmit = () => {
        setError("");

        if (!password || !confirmPassword) {
            setError("All fields are required.");
            return;
        }

        if (password !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        if (!passwordRegex.test(password)) {
            setError(
                "Password must be at least 8 characters long and include at least one uppercase letter, one number, and one special character."
            );
            return;
        }

        onSubmit(password);

    };

    return (
        <div className="reset-modal-overlay">
            <div className="reset-modal">
                <h2>Reset Password</h2>
                <p>Please enter your new password</p>

                <div className="reset-field">
                    <label>New Password</label>
                    <div className="password-input-wrapper">
                        <input
                            type={showPassword ? "text" : "password"}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter new password"
                        />
                        <span
                            className="toggle-eye"
                            onClick={() => setShowPassword(!showPassword)}
                        >
            {showPassword ? <FiEyeOff/> : <FiEye/>}
        </span>
                    </div>
                </div>

                <div className="reset-field">
                    <label>Confirm Password</label>
                    <div className="password-input-wrapper">
                        <input
                            type={showConfirmPassword ? "text" : "password"}
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirm new password"
                        />
                        <span
                            className="toggle-eye"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        >
            {showConfirmPassword ? <FiEyeOff/> : <FiEye/>}
        </span>
                    </div>
                </div>

                {error && <small className="error-text">{error}</small>}

                <div className="reset-actions">
                    <button className="submit-btn" onClick={handleSubmit}>
                        Reset Password
                    </button>
                    <button className="cancel-btn" onClick={onClose}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordModal;
